import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ButtonBlockConfig } from '@front-platform/content-builder';
import { buttonBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface ButtonBlockRuntimeConfig {
  'thick_size'?: 'S' | 'M' | 'L';
}

export type ButtonBlockConfigInput = Partial<
  Omit<ButtonBlockConfig, keyof ButtonBlockRuntimeConfig> & ButtonBlockRuntimeConfig
>;
export type ButtonBlockResolvedConfig = Omit<ButtonBlockConfig, keyof ButtonBlockRuntimeConfig> &
  Partial<ButtonBlockRuntimeConfig>;
export interface ButtonBlockContract extends ConfigComponentContract<
  ButtonBlockConfigInput,
  ButtonBlockResolvedConfig
> {}

@Component({
  selector: 'app-button-block',
  templateUrl: './button-block.component.html',
  standalone: false,
})
export class ButtonBlockComponent implements ButtonBlockContract {
  readonly config = input<ButtonBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<ButtonBlockConfig, ButtonBlockRuntimeConfig>(
    buttonBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get url(): string {
    return this.resolvedConfig()['url'] as unknown as string;
  }
  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get thickSize(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['thick_size'] as unknown as 'S' | 'M' | 'L';
  }
  get type(): 'primary' | 'light' | 'outlined' {
    return this.resolvedConfig()['type'] as unknown as 'primary' | 'light' | 'outlined';
  }
  get color(): 'neutral' | 'success' | 'primary' | 'info' | 'highligh' {
    return this.resolvedConfig()['color'] as unknown as
      'neutral' | 'success' | 'primary' | 'info' | 'highligh';
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ButtonBlockComponent, { 'keyAliases': {} });
